/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { HFlow, Text, Theme, useTheme, VFlow } from 'bold-ui'
import { CheckboxField, resolveName } from 'components/form'
import { MChatPerguntaEnum } from 'graphql/types.generated'
import { useField } from 'react-final-form'
import { MetaPath } from 'util/metaPath'

import { MCHAT_PERGUNTAS } from '../../mchat/model-mchat'
import { getMChatPerguntaNumber } from '../../mchat/utils-mchat'
import { ConsultaSeguimentoPerguntaSelectListItemStatus } from './ConsultaSeguimentoPerguntaSelectListItemStatus'

interface ConsultaSeguimentoPerguntaSelectListFieldProps {
  name: MetaPath<MChatPerguntaEnum[]>
  listOfPerguntas: MChatPerguntaEnum[]
  getListItemHasData: (pergunta: MChatPerguntaEnum) => boolean
}

export function ConsultaSeguimentoPerguntaSelectListField(
  props: Readonly<ConsultaSeguimentoPerguntaSelectListFieldProps>
) {
  const { name, listOfPerguntas, getListItemHasData } = props

  const theme = useTheme()
  const styles = createStyles(theme)

  const {
    input: { value: perguntasSelecionadas },
  } = useField<MChatPerguntaEnum[]>(resolveName(name), { subscription: { value: true } })

  const isPerguntaNotSelected = (pergunta: MChatPerguntaEnum) => {
    return !(perguntasSelecionadas ?? []).includes(pergunta)
  }

  return (
    <VFlow style={styles.list}>
      {listOfPerguntas.map((pergunta: MChatPerguntaEnum) => (
        <HFlow key={pergunta} alignItems='center' justifyContent='space-between' hSpacing={2}>
          <Text>
            {getMChatPerguntaNumber(pergunta)}. “{MCHAT_PERGUNTAS[pergunta]}”
            {isPerguntaNotSelected(pergunta) && getListItemHasData(pergunta) && (
              <ConsultaSeguimentoPerguntaSelectListItemStatus status='WARNING' />
            )}
          </Text>
          <CheckboxField name={name} value={pergunta} />
        </HFlow>
      ))}
    </VFlow>
  )
}

const createStyles = (theme: Theme) => ({
  list: css`
    & > div {
      border-bottom: 1px solid ${theme.pallete.divider};
      margin: 0;
      padding: 0.25rem 1rem;
      &:last-child {
        border-bottom: 0;
      }
    }
  `,
})
